import React from "react";
import { Check } from "lucide-react";

export default function StepIndicator({ steps, current }) {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between">
        {steps.map((step, idx) => {
          const isDone = idx < current;
          const isActive = idx === current;
          return (
            <React.Fragment key={step.title}>
              <div className="flex flex-col items-center flex-shrink-0">
                <div
                  className={`flex h-9 w-9 items-center justify-center rounded-full border-2 text-sm font-semibold transition-all duration-300 ${
                    isDone
                      ? "border-[#465EFF] bg-[#465EFF] text-white"
                      : isActive
                      ? "border-[#465EFF] bg-white text-[#465EFF] ring-4 ring-[#465EFF]/15"
                      : "border-slate-300 bg-white text-slate-400"
                  }`}
                >
                  {isDone ? <Check className="h-4 w-4" /> : idx + 1}
                </div>
                <span
                  className={`mt-2 hidden max-w-[90px] text-center text-[11px] font-medium leading-tight sm:block ${
                    isActive ? "text-[#0A1B6B]" : "text-slate-400"
                  }`}
                >
                  {step.title}
                </span>
              </div>
              {idx < steps.length - 1 && (
                <div
                  className={`mx-1 h-0.5 flex-1 rounded transition-colors duration-300 ${
                    idx < current ? "bg-[#465EFF]" : "bg-slate-200"
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
